import PropTypes from 'prop-types';
import { Table } from 'cat-ecommerce-alloy';
import { getCustomRenderers } from './utils';
import styles from '../validInvalidPartsTable.module.scss';
import { isEmpty } from '@app/utils';

const PartsTable = ({ parts, schema, isValidParts, deleteInvalidItem }) => {
  return (
    <div className={`${styles['validInvalidTable__container']}`}>
      {!isEmpty(parts) && (
        <Table
          schema={schema}
          data={parts}
          keyGenerator={item => item.partNumber}
          customRenderers={getCustomRenderers(isValidParts, deleteInvalidItem)}
        />
      )}
    </div>
  );
};

export default PartsTable;
PartsTable.propTypes = {
  parts: PropTypes.arrayOf(
    PropTypes.shape({
      itemNumber: PropTypes.string,
      partNumber: PropTypes.string,
      quantity: PropTypes.string,
      assetId: PropTypes.string
    })
  ),
  isValidParts: PropTypes.bool,
  schema: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      columnType: PropTypes.string,
      isSortable: PropTypes.bool
    })
  ),
  deleteInvalidItem: PropTypes.func
};
